import React, { useState, useEffect } from 'react';
import axios from 'axios';

import DatePicker from 'react-datepicker';
import { ru } from 'date-fns/locale';

import 'react-datepicker/dist/react-datepicker.css';

import './AddRecommendPage.css';

import eventsPhoto from './../../images/events-main-photo.jpg';
import editIcon from './../../images/events-name-edit.svg';
import searchLocation from './../../images/location-search.svg';
import locationIcon from './../../images/search.png';
import calendarIcon from './../../images/calendar.svg';

const AddRecommendPage = ({
    setCurrentPage,
    translations,
    newRecommendCategory,
    newRecommendNameRu,
    newRecommendNameEn,
    setNewRecommendNameRu,
    setNewRecommendNameEn,
    newRecommendDescriptionRu,
    newRecommendDescriptionEn,
    setNewRecommendDescriptionRu,
    setNewRecommendDescriptionEn,
    newRecommendAddress,
    newRecommendCoords,
    image,
    setImage,
    newRecommendDate,
    setNewRecommendDate,
    userLang,
    setNewRecommendCategory,
    setNewRecommendAddress,
    setNewRecommendCoords,
    isFullScreenMode,
}) => {
    const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);
    const [isDateSelected, setIsDateSelected] = useState(false);
    const currentDate = new Date();

    const handleNewCategoryClick = () => {
        setCurrentPage('NewTypeRecommend');
    };

    const handleNewLocationClick = () => {
        setCurrentPage('NewRecommendMapPage');
    };

    // обработка картинки
    const handleImageChange = (e) => {
        const file = e.target.files[0];

        if (file && file.size > 250 * 1024) {
            alert(translations.alertImage);
            return;
        }

        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setImage(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };

    const handleNewDateClick = () => {
        setIsDatePickerOpen(true);
    };

    const handleDateChange = (date) => {
        setNewRecommendDate(date);
        setIsDateSelected(true);

        if (date && date.getTime() !== currentDate.getTime()) {
            setIsDatePickerOpen(false);
        }
    };

    const handleDatePickerClose = () => {
        if (isDateSelected) {
            setIsDatePickerOpen(false);
        }
    };

    const formatEventDate = (date) => {
        const formattedDate = date.toLocaleString('ru-RU', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
        });
        return formattedDate;
    };

    const handleSaveRecommendClick = async () => {
        if (
            newRecommendCategory &&
            newRecommendDate &&
            newRecommendAddress &&
            image &&
            newRecommendNameRu &&
            newRecommendNameEn &&
            newRecommendDescriptionRu &&
            newRecommendDescriptionEn
        ) {
            try {
                const response = await axios.post(
                    'https://mepointserver.ru/user/ad/create',
                    {
                        eventSubCategoryId: newRecommendCategory.id,
                        end: newRecommendDate.toISOString(),
                        city: newRecommendAddress.split(',')[0].trim(),
                        latitude: newRecommendCoords[0],
                        longitude: newRecommendCoords[1],
                        address: newRecommendAddress,
                        image: image.split(';base64,')[1],
                        nameRu: newRecommendNameRu,
                        nameEn: newRecommendNameEn,
                        descriptionRu: newRecommendDescriptionRu,
                        descriptionEn: newRecommendDescriptionEn,
                        userId: null,
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem(
                                'authToken'
                            )}`,
                        },
                    }
                );
                if (response.data.success) {
                    setCurrentPage('UserPage');
                    setNewRecommendCategory(null);
                    setNewRecommendDate(null);
                    setNewRecommendAddress(null);
                    setNewRecommendCoords(null);
                    setImage(null);
                    setNewRecommendNameRu(null);
                    setNewRecommendNameEn(null);
                    setNewRecommendDescriptionRu(null);
                    setNewRecommendDescriptionEn(null);
                }
            } catch (error) {
                console.error('Ошибка при создании рекомендации ', error);
            }
        } else {
            alert('Заполните все поля');
        }
    };

    return (
        <div className='add__recommend'>
            <div
                className={
                    isFullScreenMode
                        ? 'add__recommend_container_full'
                        : 'add__recommend_container'
                }
            >
                <div
                    className={
                        isFullScreenMode
                            ? 'add__recommend_title_full'
                            : 'add__recommend_title'
                    }
                >
                    <h1>{translations.createRecommend}</h1>
                </div>
                <div className='add__recommend_wrapper'>
                    <div className='add__recommend_items'>
                        <div
                            className='events__name'
                            onClick={handleNewCategoryClick}
                        >
                            <img
                                className='events__main_photo'
                                src={
                                    newRecommendCategory
                                        ? 'https://mepointserver.ru' +
                                          newRecommendCategory.imageLink
                                        : eventsPhoto
                                }
                                alt='events'
                            />
                            <h3 className='events__title'>
                                {newRecommendCategory
                                    ? newRecommendCategory.name
                                    : `${translations.selectCategory}`}
                            </h3>
                            <img
                                className='events__title_edit'
                                src={editIcon}
                                alt='edit'
                            />
                        </div>

                        <div className='events__data'>
                            <h5>{translations.nameRu}</h5>
                            <input
                                type='text'
                                value={newRecommendNameRu}
                                onChange={(e) =>
                                    setNewRecommendNameRu(e.target.value)
                                }
                                className={`add__recommend_input ${
                                    newRecommendNameRu ? 'active' : ''
                                }`}
                            />
                        </div>

                        <div className='events__data'>
                            <h5>{translations.nameEn}</h5>
                            <input
                                type='text'
                                value={newRecommendNameEn}
                                onChange={(e) =>
                                    setNewRecommendNameEn(e.target.value)
                                }
                                className={`add__recommend_input ${
                                    newRecommendNameEn ? 'active' : ''
                                }`}
                            />
                        </div>

                        <div className='events__description'>
                            <h5>{translations.recommendDescriptionRu}</h5>
                            <textarea
                                value={newRecommendDescriptionRu}
                                onChange={(e) =>
                                    setNewRecommendDescriptionRu(e.target.value)
                                }
                                placeholder={
                                    translations.shortDescriptionRecommendRu
                                }
                            ></textarea>
                        </div>

                        <div className='events__description'>
                            <h5>{translations.recommendDescriptionEn}</h5>
                            <textarea
                                value={newRecommendDescriptionEn}
                                onChange={(e) =>
                                    setNewRecommendDescriptionEn(e.target.value)
                                }
                                placeholder={
                                    translations.shortDescriptionRecommendEn
                                }
                            ></textarea>
                        </div>

                        <div className='events__location'>
                            <h5>{translations.recommendImage}</h5>
                            <div className='edit__image_items'>
                                <input
                                    type='file'
                                    accept='image/*'
                                    onChange={handleImageChange}
                                    className='image__change'
                                    id='imageEdit'
                                />
                                <label htmlFor='imageEdit'>
                                    <img
                                        src={image}
                                        alt={
                                            image !== null &&
                                            `${translations.recommendImage}`
                                        }
                                    />
                                </label>
                            </div>
                        </div>

                        <div className='events__data'>
                            <h5>{translations.recommendDate}</h5>
                            <div
                                className={`input__data ${
                                    newRecommendDate ? 'active' : ''
                                }`}
                                onClick={handleNewDateClick}
                            >
                                <p>
                                    {newRecommendDate
                                        ? formatEventDate(newRecommendDate)
                                        : formatEventDate(currentDate)}
                                </p>
                                <img
                                    className='calendar__icon'
                                    src={calendarIcon}
                                />
                            </div>
                        </div>
                        {isDatePickerOpen && (
                            <DatePicker
                                selected={newRecommendDate || currentDate}
                                onChange={handleDateChange}
                                onClickOutside={handleDatePickerClose}
                                showTimeSelect
                                timeFormat='HH:mm'
                                timeIntervals={15}
                                dateFormat='dd.MM.yyyy HH:mm'
                                locale={userLang === 'ru-RU' ? ru : undefined}
                                minDate={currentDate}
                                inline
                            />
                        )}

                        <div className='events__location'>
                            <h5>{translations.location}</h5>

                            <div
                                className={`input__location ${
                                    newRecommendAddress ? 'active' : ''
                                }`}
                                onClick={handleNewLocationClick}
                            >
                                <img
                                    className='search__icon'
                                    src={searchLocation}
                                />
                                <p>
                                    {newRecommendAddress
                                        ? newRecommendAddress
                                        : `${translations.selectLocation}`}
                                </p>
                                <img
                                    className='location__icon'
                                    src={locationIcon}
                                />
                            </div>
                        </div>

                        <div
                            className={`events__button ${
                                newRecommendCategory &&
                                newRecommendNameRu &&
                                newRecommendNameEn &&
                                newRecommendDescriptionRu &&
                                newRecommendDescriptionEn &&
                                image &&
                                newRecommendAddress &&
                                newRecommendDate
                                    ? 'active'
                                    : ''
                            }`}
                        >
                            <button onClick={handleSaveRecommendClick}>
                                {translations.create}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddRecommendPage;
